// extracted by mini-css-extract-plugin
export default {"faq_block":"faq_block___oXzMR","final":"final___OglXU","final_bg":"final_bg___IrzNw","final_container":"final_container___Yi2lE","final_btn":"final_btn___NQjhu"};